import { useMemo } from 'react'
import { GridNode } from '../common/shared/grid-item'
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { LibraryMenu } from '../common/menu/node-actions'
import { IconLibrary } from '../../../../../shared/icon/icon'

export const NodeLibraryGridItem = ({ node, dataContext }) => {
  const { url } = useRouteMatch()

  const to = useMemo(() => `${url}/library/${node.id}`, [url, node])

  const FooterMenu = () => <LibraryMenu place="card" url={`${url}/library/${node.id}`} />

  return <GridNode Icon={IconLibrary} FooterMenu={FooterMenu} node={node} to={to} dataContext={dataContext} />
}
